import * as React from "react";
import {css, cx} from "emotion";

import "./multi-select.scss";

import {cs} from "@Common/react/chain-services";

import {Dropdown} from "../../../../dropdown/dropdown";
import {keyed} from "../../../../../react/keyed";
import {Checkbox} from "../checkbox/checkbox";

export const MultiSelect = (
    {
        list, style=undefined, className=undefined, placeholder=undefined, domRef: domRef1 = undefined,
        onClear=undefined, itemToLabel, forcedExpandLeft=undefined, onSelect, onRemove, isSelected,
        captureOutsideClicks=true, // Use this if select is inside modal, if outside modal, don't use, it will be more natural
        xdQaNamePrefix=undefined,
    }
) => cs(
    ["small", (_, next) => next(style?.height < 36)],
    ["selectedItems", (_, next) => next(list?.filter(isSelected))],
    ["addXdQaNamePrefix", (_, next) => next(xdQaNamePrefix==null ? v=>v : (v)=>xdQaNamePrefix + " " + v)],
    ({small, selectedItems, addXdQaNamePrefix}) => Dropdown({
        forcedExpandLeft,
        renderToggle: ({showExpand, domRef}) => (
            <div
                className={cx(
                    "select multi-select multi-select-3ee toggle",
                    css`
                        --height: ${style?.height??36}px;
                    `,
                    {small},
                    style?.color,
                    className,
                )}
                onClick={() => showExpand()}
                ref={!(domRef || domRef1) ? undefined : (ref) => {
                    domRef?.(ref);
                    domRef1?.(ref);
                }}
                xd-qa-type="dropdown"
                xd-qa-name={xdQaNamePrefix}
            >

                <div
                    className="main"
                >
                    {!selectedItems?.length ? (
                        <div
                            className={cx(
                                "placeholder",
                                css`
                                    font-size: ${style?.fontSize??14}px;
                                `,
                            )}
                        >
                            {placeholder}
                        </div>
                    ) : (
                        <div className="items">
                            {selectedItems.map((item, i) => cs(
                                keyed(i),
                                () => (
                                    <div className="item">
                                        <div className="text" xd-qa-type="label" xd-qa-name={addXdQaNamePrefix(itemToLabel(item)+" Selected")}>
                                            {itemToLabel(item)}
                                        </div>

                                        {/*<i className="fa fa-close"/>*/}
                                        <div
                                            className="close"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onRemove(item);
                                            }}
                                            xd-qa-type="icon"
                                            xd-qa-name={addXdQaNamePrefix(itemToLabel(item)+" Remove")}
                                        >&times;</div>
                                    </div>
                                ),
                            ))}
                        </div>
                    )}
                </div>

                <div className={cx("dropdown-indicator", {small})} xd-qa-type="icon" xd-qa-name={addXdQaNamePrefix("Dropdown")}>
                    {!small ? (
                        <div className="up-down">
                            <i className="fa fa-chevron-up"/>
                            <i className="fa fa-chevron-down"/>
                        </div>
                    ) : (
                        <div className="down">
                            <i className="fa fa-angle-down"/>
                        </div>
                    )}
                </div>
            </div>
        ),
        renderExpand: ({position, width, close, domRef}) => (
            <div
                className={cx("multi-select-3ee expand", {capture: captureOutsideClicks})}
                onClick={close}
                ref={domRef}
            >
                <div
                    className={cx("box", css`
                    //--height: ${style?.height??36}px;
                    --height: ${36}px;
                `)}
                    style={{...position, width}}
                    onClick={(e) => e.stopPropagation()}
                >

                    <div className="box">

                        <div className="items">
                            {list?.map((item, i) => {
                                const selected = isSelected(item);
                                return (
                                    <div
                                        className={cx("item")}
                                        key={i}
                                        onClick={() => !selected ? onSelect(item) : onRemove(item)}
                                    >
                                        {Checkbox({
                                            checked: selected,
                                            xdQaName: addXdQaNamePrefix(itemToLabel(item)),
                                        })}
                                        <div className="label" xd-qa-type="dropdown_item" xd-qa-name={addXdQaNamePrefix(itemToLabel(item))}>
                                            {itemToLabel(item)}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {!!selectedItems?.length && onClear && (
                            <div className="footer">
                                <a
                                    onClick={() => {
                                        // close();
                                        onClear();
                                    }}
                                    xd-qa-type="link"
                                    xd-qa-name={addXdQaNamePrefix("Clear Selection")}
                                >
                                    Clear Selection
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        ),
    })
);
